export default "__VITE_PUBLIC_ASSET__1693e47e__"